import React, { ComponentPropsWithoutRef } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  DomainObject,
  ScrollableSource,
  TableFieldColumn,
} from '@eas/common-web';
import { CollectionField } from '@components/collection-field/collection-field';
import { DictionaryAutocomplete } from '@models';
import { EvidenceApiUrl } from '@enums';
import { useColumns } from './activity-columns';

interface ActivityFieldProps
  extends Partial<
    ComponentPropsWithoutRef<typeof CollectionField<DictionaryAutocomplete>>
  > {
  source: ScrollableSource<DictionaryAutocomplete>;
  hideRedirectInCurrent?: boolean;
}

export function ActivityField({
  source,
  hideRedirectInCurrent,
  ...overrides
}: ActivityFieldProps) {
  return (
    <CollectionField<DictionaryAutocomplete>
      title={
        <FormattedMessage
          id="ZSD__FIELD_LABEL__ACTIVITIES"
          defaultMessage="Činnosti"
        />
      }
      source={source}
      columnsProps={{ hideRedirectInCurrent }}
      useColumns={
        useColumns as <T extends DomainObject>() => TableFieldColumn<T>[]
      }
      disabled={true}
      createAction={{
        hide: true,
        getUrl: () => EvidenceApiUrl.ACTIVITIES,
      }}
      readAction={{
        getUrl: (collectionId) =>
          `${EvidenceApiUrl.ACTIVITIES}/${collectionId}`,
      }}
      updateAction={{
        hide: true,
        getUrl: (_, collectionId) =>
          `${EvidenceApiUrl.ACTIVITIES}/${collectionId}`,
      }}
      deleteAction={{
        hide: true,
        getUrl: (_, collectionId) =>
          `${EvidenceApiUrl.ACTIVITIES}/${collectionId}`,
      }}
      assignAction={{
        hide: true,
        getUrl: (_, collectionId) =>
          `${EvidenceApiUrl.ACTIVITIES}/${collectionId}`,
      }}
      unassignAction={{
        hide: true,
        getUrl: (_, collectionId) =>
          `${EvidenceApiUrl.ACTIVITIES}/${collectionId}`,
      }}
      {...overrides}
    />
  );
}
